import { numberFormatAsString } from "commons/ultilities";
import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import {
  DimensionAndWeightConstants,
  DimensionAndWeightFixDecimalConstants,
} from "./const";

export const DimensionAndWeight = types
  .model({
    lengthUpper: types.maybeNull(types.number),
    lengthStandard: types.maybeNull(types.number),
    lengthLower: types.maybeNull(types.number),
    widthUpper: types.maybeNull(types.number),
    widthStandard: types.maybeNull(types.number),
    widthLower: types.maybeNull(types.number),
    heightUpper: types.maybeNull(types.number),
    heightStandard: types.maybeNull(types.number),
    heightLower: types.maybeNull(types.number),
    weightUpper: types.maybeNull(types.number),
    weightStandard: types.maybeNull(types.number),
    weightLower: types.maybeNull(types.number),
    planeSpecPaperSize: types.maybeNull(types.number),
    planeSpecLength: types.maybeNull(types.number),
    otherStandardSelect: types.maybeNull(types.string),
    otherStandardText: types.maybeNull(types.string),
    lengthUpperFactorNumber: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_LENGTH_UPPER_FACTOR_NUMBER,
      ),
    ),
    lengthLowerFactorNumber: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_LENGTH_LOWER_FACTOR_NUMBER,
      ),
    ),
    widthUpperFactorNumber: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_WIDTH_UPPER_FACTOR_NUMBER,
      ),
    ),
    widthLowerFactorNumber: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_WIDTH_LOWER_FACTOR_NUMBER,
      ),
    ),
    heightUpperFactorNumber: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_HEIGHT_UPPER_FACTOR_NUMBER,
      ),
    ),
    heightLowerFactorNumber: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_HEIGHT_LOWER_FACTOR_NUMBER,
      ),
    ),
    weightLowerFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_WEIGHT_LOWER_FACTOR_PERCENT,
      ),
    ),
    weightUpperFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        DimensionAndWeightConstants.DEFAULT_WEIGHT_UPPER_FACTOR_PERCENT,
      ),
    ),
    appearanceSelect: types.maybeNull(types.string),
    appearanceText: types.maybeNull(types.string),
    foldingStandardSize: types.maybeNull(types.string),
    foldingStandardCount: types.maybeNull(types.string),
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get lengthStandardDisplay() {
      return self.lengthStandard
        ? `${numberFormatAsString(self.lengthStandard.toString(), {
            decimalScale: DimensionAndWeightFixDecimalConstants.LENGTH_STANDARD,
            fixedDecimalScale: true,
          })}`
        : "";
    },
    get lengthUpperWithFactorNumberDisplay() {
      const lengthUpper = `${
        self.lengthUpperFactorNumber
          ? `+${numberFormatAsString(self?.lengthUpperFactorNumber.toString(), {
              decimalScale:
                DimensionAndWeightFixDecimalConstants.LENGTH_UPPER_FACTOR,
              fixedDecimalScale: true,
            })}mm`
          : ""
      }${
        self.lengthUpper
          ? `~${numberFormatAsString(self.lengthUpper?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.LENGTH_UPPER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return lengthUpper || "";
    },
    get lengthLowerWithFactorNumberDisplay() {
      const lengthLower = `${
        self.lengthLowerFactorNumber
          ? `-${numberFormatAsString(self?.lengthLowerFactorNumber.toString(), {
              decimalScale:
                DimensionAndWeightFixDecimalConstants.LENGTH_LOWER_FACTOR,
              fixedDecimalScale: true,
            })}mm`
          : ""
      }${
        self.lengthLower
          ? `~${numberFormatAsString(self.lengthLower?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.LENGTH_LOWER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return lengthLower || "";
    },
    get widthStandardDisplay() {
      return self.widthStandard
        ? `${numberFormatAsString(self.widthStandard.toString(), {
            decimalScale: DimensionAndWeightFixDecimalConstants.WIDTH_STANDARD,
            fixedDecimalScale: true,
          })}`
        : "";
    },
    get widthUpperWithFactorNumberDisplay() {
      const widthUpper = `${
        self.widthUpperFactorNumber
          ? `+${numberFormatAsString(self?.widthUpperFactorNumber.toString(), {
              decimalScale:
                DimensionAndWeightFixDecimalConstants.WIDTH_UPPER_FACTOR,
              fixedDecimalScale: true,
            })}mm`
          : ""
      }${
        self.widthUpper
          ? `~${numberFormatAsString(self.widthUpper?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.WIDTH_UPPER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return widthUpper || "";
    },
    get widthLowerWithFactorNumberDisplay() {
      const widthLower = `${
        self.widthLowerFactorNumber
          ? `-${numberFormatAsString(self?.widthLowerFactorNumber.toString(), {
              decimalScale:
                DimensionAndWeightFixDecimalConstants.WIDTH_LOWER_FACTOR,
              fixedDecimalScale: true,
            })}mm`
          : ""
      }${
        self.widthLower
          ? `~${numberFormatAsString(self.widthLower?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.WIDTH_LOWER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return widthLower || "";
    },
    get heightStandardDisplay() {
      return self.heightStandard
        ? `${numberFormatAsString(self.heightStandard.toString(), {
            decimalScale: DimensionAndWeightFixDecimalConstants.HEIGHT_STANDARD,
            fixedDecimalScale: true,
          })}`
        : "";
    },
    get heightUpperWithFactorNumberDisplay() {
      const heightUpper = `${
        self.heightUpperFactorNumber
          ? `+${numberFormatAsString(self?.heightUpperFactorNumber.toString(), {
              decimalScale:
                DimensionAndWeightFixDecimalConstants.HEIGHT_UPPER_FACTOR,
              fixedDecimalScale: true,
            })}mm`
          : ""
      }${
        self.heightUpper
          ? `~${numberFormatAsString(self.heightUpper?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.HEIGHT_UPPER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return heightUpper || "";
    },
    get heightLowerWithFactorNumberDisplay() {
      const heightLower = `${
        self.heightLowerFactorNumber
          ? `-${numberFormatAsString(self?.heightLowerFactorNumber.toString(), {
              decimalScale:
                DimensionAndWeightFixDecimalConstants.HEIGHT_LOWER_FACTOR,
              fixedDecimalScale: true,
            })}mm`
          : ""
      }${
        self.heightLower
          ? `~${numberFormatAsString(self.heightLower?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.HEIGHT_LOWER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return heightLower || "";
    },
    get weightStandardDisplay() {
      return self.weightStandard
        ? `${numberFormatAsString(self.weightStandard.toString(), {
            decimalScale: DimensionAndWeightFixDecimalConstants.WEIGHT_STANDARD,
            fixedDecimalScale: true,
          })}`
        : "";
    },
    get weightUpperWithFactorPercentDisplay() {
      const weightUpper = `${
        self.weightUpperFactorPercent
          ? `+${numberFormatAsString(
              self?.weightUpperFactorPercent.toString(),
              {
                decimalScale:
                  DimensionAndWeightFixDecimalConstants.WEIGHT_UPPER_FACTOR,
                fixedDecimalScale: true,
              },
            )}%`
          : ""
      }${
        self.weightUpper
          ? `~${numberFormatAsString(self.weightUpper?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.WEIGHT_UPPER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return weightUpper || "";
    },
    get weightLowerWithFactorPercentDisplay() {
      const weightLower = `${
        self.weightLowerFactorPercent
          ? `-${numberFormatAsString(
              self?.weightLowerFactorPercent.toString(),
              {
                decimalScale:
                  DimensionAndWeightFixDecimalConstants.WEIGHT_LOWER_FACTOR,
                fixedDecimalScale: true,
              },
            )}%`
          : ""
      }${
        self.weightLower
          ? `~${numberFormatAsString(self.weightLower?.toString(), {
              decimalScale: DimensionAndWeightFixDecimalConstants.WEIGHT_LOWER,
              fixedDecimalScale: true,
            })}`
          : ""
      }`;
      return weightLower || "";
    },
  }));
export interface IDimensionAndWeight extends Instance<
  typeof DimensionAndWeight
> {}
export interface IDimensionAndWeightProperties extends SnapshotIn<
  typeof DimensionAndWeight
> {}
